import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 3000); // auto-dismiss after 3s
        return () => clearTimeout(timer);
    }, [onClose]);

    const colors = {
        success: { background: '#111', color: '#fff' },
        error:   { background: '#e74c3c', color: '#fff' },
    };

    return (
        <div style={{
            position: 'fixed',
            top: '32px',
            right: '32px',
            zIndex: 9999,
            ...colors[type],
            padding: '14px 24px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            minWidth: '280px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            animation: 'slideIn 0.3s ease',
        }}>
            <span style={{ fontSize: '1.1rem' }}>
                {type === 'success' ? '✓' : '✕'}
            </span>
            <span style={{ fontSize: '0.9rem', letterSpacing: '0.5px', flex: 1 }}>
                {message}
            </span>
            <button
                onClick={onClose}
                style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', fontSize: '1rem', padding: 0, opacity: 0.7 }}
            >
                ✕
            </button>

            <style>{`
                @keyframes slideIn {
                    from { transform: translateX(100px); opacity: 0; }
                    to   { transform: translateX(0);     opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default Toast;
